import React, { useRef } from 'react';
import truncate from 'truncate-markup-string';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { useSelector } from 'react-redux';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';

const TaxonomyMaterialTypeTeaser = ({ entity }) => {
  const title = entity.getIn(['name', 0, 'value'], '');
  const imagSrc = entity.getIn(['field_icon', 0, 'styles', 'icon']);
  const body = entity.getIn(['description', 0, 'processed']);
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));
  const path = entity.getIn(['paths', currentLanguage]);
  const charLimit = 80;
  const openTag = '<span>';
  const closeTag = '</span>';
  const prettyEllipsis = true;

  return (
    <article className="TaxonomyMaterialTypeTeaser">
      <CoreLink href={path}>
        <div className="row">
          <div className="col-3 col-md-1">
            <Image
              lazyload={false}
              className="TaxonomyMaterialTypeTeaser__image"
              src={imagSrc}
            />
          </div>
          <div className="TaxonomyMaterialTypeTeaser__body__wrapper col-6 col-md-10">
            <h3 className="TaxonomyMaterialTypeTeaser__title">{title}</h3>
            <WysiwygField
              property="schema:text"
              html={truncate(body, charLimit, openTag, closeTag, prettyEllipsis)}
              className="TaxonomyMaterialTypeTeaser__body"
            />
          </div>
          <div className="col-1 TaxonomyMaterialTypeTeaser__icon">
            <i className="icon icon-arrow" />
          </div>
        </div>
      </CoreLink>
    </article>
  );
};

export default TaxonomyMaterialTypeTeaser;
